import { FormattedMessage } from "react-intl";
import renderDateTime from "utils/renderDateTime";

import * as Styled from "./styles";
import { TicketBoxProps } from "./types";

const TicketBox: React.FC<TicketBoxProps> = ({
  ticketNumber,
  status,
  name,
  order,
  ticketPool,
  date,
}) => (
  <Styled.Wrapper>
    <Styled.Heading>{status}</Styled.Heading>
    <Styled.Description>
      {order?.firstName} {order?.lastName}
    </Styled.Description>
    <Styled.Description>{order?.email}</Styled.Description>
    <Styled.Description>
      <Styled.DescriptionLabel>
        <FormattedMessage defaultMessage="ID:" />
      </Styled.DescriptionLabel>
      {ticketNumber}
    </Styled.Description>
    <Styled.Description>
      <Styled.DescriptionLabel>
        <FormattedMessage defaultMessage="Ticket Type:" />
      </Styled.DescriptionLabel>
      {name}
    </Styled.Description>
    <Styled.Description>
      <Styled.DescriptionLabel>
        <FormattedMessage defaultMessage="Event:" />
      </Styled.DescriptionLabel>
      {ticketPool?.event?.name}{" "}
      {renderDateTime(date, ticketPool?.event?.timezone)}
    </Styled.Description>
    <Styled.Description>
      <Styled.DescriptionLabel>
        <FormattedMessage defaultMessage="Order ID:" />
      </Styled.DescriptionLabel>
      {order?.orderNumber}
    </Styled.Description>
    <Styled.Description>
      <Styled.DescriptionLabel>
        <FormattedMessage defaultMessage="Notes:" />
      </Styled.DescriptionLabel>
      {order?.customerNotes || "-"}
    </Styled.Description>
  </Styled.Wrapper>
);

export default TicketBox;
